/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_RatingInputs */

const en_feedback_rating = /** @type {(inputs: Feedback_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How useful was this?`)
};

const id_feedback_rating = /** @type {(inputs: Feedback_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seberapa berguna?`)
};

/**
* | output |
* | --- |
* | "How useful was this?" |
*
* @param {Feedback_RatingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const feedback_rating = /** @type {((inputs?: Feedback_RatingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_RatingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_feedback_rating(inputs)
	return en_feedback_rating(inputs)
});